<div class="sales-approval-container">
  <h2>Stock Approval</h2>

  <div class="toolbar">
    <button (click)="loadData()">🔄 Refresh</button>
    <button (click)="approveSelected()">✅ Approve</button>
   </div>

   <table class="styled-table" border="1">
  <thead>
    <tr>
      <th>Select</th>
      <th>#</th>
       <th>BarCode</th>
      
      <th>From store</th>
      <th>To store</th>
     <th>Employer Name</th>
     <th>Receiver Name</th>
     <th>Qty</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let sale of salesList; let i = index">
      <td><input type="radio" name="selected" (change)="selectRow(sale)" /></td>
      <td>{{ i + 1 }}</td>
      <td>{{ sale.Barcode }}</td>
      <td>{{ sale.FromStore }}</td>
      <td>{{ sale.ToStore }}</td>
      <td>{{ sale.EmployeeName }}</td>
      <td>{{ sale.ReceiverName }}</td>
      <td>{{ sale.Qty }}</td>
    </tr>
    <tr *ngIf="salesList.length === 0">
      <td colspan="6" style="text-align:center;">No sales data available</td>
    </tr>
  </tbody>
</table>


  
</div>
